import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const PAGE_LOOKUP_URL = process.env.REACT_APP_PAGE_LOOKUP_URL || '';
const PAGE_LOOKUP_API_KEY = process.env.REACT_APP_PAGE_LOOKUP_API_KEY || '';

export type RegisterPageBody = {
  page_id: string;
  account_id: string;
  env?: string;
};

export const pageLookupApi = createApi({
  reducerPath: 'pageLookupApi',
  baseQuery: fetchBaseQuery({
    baseUrl: PAGE_LOOKUP_URL,
    prepareHeaders: headers => {
      if (PAGE_LOOKUP_API_KEY) headers.set('x-api-key', PAGE_LOOKUP_API_KEY);
      return headers;
    }
  }),
  endpoints: build => ({
    getPage: build.query<any, string>({
      query: pageId => ({ url: '', method: 'GET', params: { page_id: pageId } })
    }),
    registerPage: build.mutation<any, RegisterPageBody>({
      query: body => ({ url: '', method: 'POST', body })
    }),
    getAllPages: build.query<any, void>({
      query: () => ({
        url: '',
        method: 'GET',
        params: { page_id: 'all' }
      })
    })
  })
});

export const { useLazyGetPageQuery, useLazyGetAllPagesQuery, useRegisterPageMutation } =
  pageLookupApi;
